/**
 * Functions and constants useful to handle Gemba walks stats components
 */
export const CL_ITEMS_CHART_TYPES = [
  { type: 'line', i18nLabel: 'message.LINE' },
  { type: 'bar', i18nLabel: 'message.BARS' },
];

/** Availabel stats */
export const AVAILABLE_STATS = [
  { id: 0, i18nLabel: 'message.GW_PLANNING_CHART' },
  { id: 1, i18nLabel: 'message.GW_ITEMS_OK_CHART' },
  { id: 2, i18nLabel: 'message.GW_NOK_ITEMS_PARETO' },
  { id: 3, i18nLabel: 'message.GW_NOK_ITEMS_PARETO_ZONES' },
  { id: 4, i18nLabel: 'message.GW_NOK_ITEMS_PARETO_TEAMS' },
];

export default {
  CL_ITEMS_CHART_TYPES,
  AVAILABLE_STATS,
};
